import { UserTypeDirective } from "./user-type/user-type.directive";
import { AccountTypeDirective } from "./account-type/account-type.directive";
import { UserRoleDirective } from "./user-role/user-role.directive";
import { TooltipDirective } from "./tooltip/tooltip.directive";
import { LockGuardDirective } from "./lock-guard/lock-guard.directive";
import { InlineSvgDirective } from "./inline-svg/inline-svg.directive";
import { BoardImageDirective } from "./board-image/board-image.directive";
import { ScrollShadowDirective } from "./scroll-shadow/scroll-shadow.directive";
import { HidePriceDirective } from "./hide-price/hide-price.directive";
import { WholeMillimetresDirective } from "./whole-millimetres/whole-millimetres.directive";

export const Directives = [
	UserTypeDirective,
	UserRoleDirective,
	TooltipDirective,
	AccountTypeDirective,
	LockGuardDirective,
	InlineSvgDirective,
	BoardImageDirective,
	ScrollShadowDirective,
	HidePriceDirective,
	WholeMillimetresDirective,
]
